// Function loadSupplierListingItemBlock loads the supplierProductBlock class by dynamically importing the js on demand if needed

export function loadSupplierListingItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-supplier-listing-item-block-chunk" */ '../widgets/supplierListingItemBlock').then(wg => {

		const { SupplierListingItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SupplierListingItemBlock"]');

		if(!$wg) {
			// console.info('SupplierListingItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SupplierListingItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SuppplierListingItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SupplierListingItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the SupplierListingItemBlock widget');

}
